import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { get } from '@totalsoft/change-tracking-react';
import { Grid, Switch, FormControlLabel, Typography } from '@mui/material';
import LoadingWrapper from 'components/common/LoadingWrapper';

const OfferDataSummary = ({
  assetDescription,
  assetLoading,
  insuredLens,
  insuredLoading,
  clientLens,
  clientLoading,
  isPF,
  insuredIsClient
}) => {
  const { t } = useTranslation();

  const getInsuredName = () =>
    isPF ? `${(insuredLens.firstName |> get) || ''} ${(insuredLens.lastName |> get) || ''}` : (insuredLens.partnerName |> get) || '';

  const getClientName = () =>
    isPF ? `${(clientLens.firstName |> get) || ''} ${(clientLens.lastName |> get) || ''}` : (clientLens.partnerName |> get) || '';

  return (
    <Grid container alignItems={'center'}>
      {insuredIsClient ? (
        <>
          <span>{t('Offer.Edit.OfferData.Partner.InsuredAndUser')}</span>{' '}
        </>
      ) : (
        <>
          <span>{t('Offer.Edit.OfferData.Partner.Insured')}</span>{' '}
        </>
      )}
      <Grid item xs={insuredLoading ? 6 : undefined} md={insuredLoading ? 2 : undefined} mx={1}>
        <LoadingWrapper loading={insuredLoading}>
          <strong>{getInsuredName()}</strong>
        </LoadingWrapper>
      </Grid>
      <span>{`${t('Offer.Edit.OfferData.Partner.UniqueId')}`}</span>
      <Grid item xs={insuredLoading ? 6 : undefined} md={insuredLoading ? 2 : undefined} mx={1}>
        <LoadingWrapper loading={insuredLoading}>
          <strong>{insuredLens.uniqueID |> get}</strong>
        </LoadingWrapper>
      </Grid>
      {!insuredIsClient ? (
        <>
          <span>{t('Offer.Edit.OfferData.Partner.User')}</span>{' '}
          <Grid item xs={clientLoading ? 6 : undefined} md={clientLoading ? 2 : undefined} mx={1}>
            <LoadingWrapper loading={clientLoading}>
              <strong>{getClientName()}</strong>
            </LoadingWrapper>
          </Grid>
          <span>{`${t('Offer.Edit.OfferData.Partner.UniqueId')}`}</span>
          <Grid item xs={clientLoading ? 6 : undefined} md={clientLoading ? 2 : undefined} mx={1}>
            <LoadingWrapper loading={clientLoading}>
              <strong>{clientLens.uniqueID |> get}</strong>
            </LoadingWrapper>
          </Grid>
        </>
      ) : (
        <FormControlLabel
          control={<Switch id='Insured.InsuredIsClient' checked={insuredIsClient} color='primary' disabled={true} />}
          label={<Typography>{t('Offer.Edit.OfferData.Partner.InsuredIsClient')}</Typography>}
        />
      )}
      <span>{t('Offer.Edit.OfferData.Asset.Title')}:</span>{' '}
      <Grid item xs={assetLoading ? 6 : undefined} md={assetLoading ? 2 : undefined} mx={1}>
        <LoadingWrapper loading={assetLoading}>
          <strong id='OfferData_Asset_Summary'>{assetDescription}</strong>
        </LoadingWrapper>
      </Grid>
    </Grid>
  );
};

OfferDataSummary.propTypes = {
  assetDescription: PropTypes.string,
  assetLoading: PropTypes.bool,
  insuredLens: PropTypes.object,
  insuredLoading: PropTypes.bool,
  clientLens: PropTypes.object,
  clientLoading: PropTypes.bool,
  isPF: PropTypes.bool,
  insuredIsClient: PropTypes.bool
};

export default OfferDataSummary;
